import { ContractState, ContractViewModel, EndIntention, VehicleNature } from '@ail/contracts-api'

export enum ContractProduct {
  GMLeasing = 'GM-Leasing',
  GMLeasingGold = 'GM-Leasing Gold',
  FullServiceLease = 'Full Service Lease',
  ManagementOnly = 'Management Only',
  DCSLMOoffen = 'DCSL MO - offen',
  Medlease = 'Medlease',
  GM = 'GM',
  PTMFullGeschlossen = 'PTMFullGeschlossen',
  FullDistance = 'FullDistance',
  EFLLagerfinanzierungPhase1 = 'EFL Lagerfinanzierung Phase 1',
  ExternalFin = 'ExternalFin',
  Fin = 'Fin',
  FinPlus = 'FinPlus',
  FullClosed = 'FullClosed',
  FullOpen = 'FullOpen',
  FullOpenPlus = 'FullOpenPlus',
  Mo = 'Mo',
  MoClosed = 'MoClosed',
  SimpleXFleet = 'SimpleXFleet',
  Mitarbeiterleasing = 'Mitarbeiterleasing',
}

export const ContractProductMap: Partial<Record<number, ContractProduct>> = {
  200046: ContractProduct.GM,
  200160: ContractProduct.FullOpen,
  200168: ContractProduct.Mo,
  208251: ContractProduct.Mo,
  217258: ContractProduct.Medlease,
  217266: ContractProduct.GM,
  217272: ContractProduct.FullClosed,
  217275: ContractProduct.FullDistance,
  217276: ContractProduct.EFLLagerfinanzierungPhase1,
  207012: ContractProduct.GMLeasingGold,
  217280: ContractProduct.ExternalFin,
  217278: ContractProduct.Fin,
  200007: ContractProduct.Fin,
  217289: ContractProduct.Fin,
  217293: ContractProduct.Fin,
  200169: ContractProduct.Fin,
  200127: ContractProduct.Fin,
  217290: ContractProduct.FinPlus,
  200097: ContractProduct.FinPlus,
  200130: ContractProduct.FinPlus,
  200086: ContractProduct.FullClosed,
  214935: ContractProduct.FullClosed,
  217287: ContractProduct.FullClosed,
  217279: ContractProduct.FullClosed,
  200191: ContractProduct.FullOpen,
  217286: ContractProduct.FullOpen,
  200117: ContractProduct.FullOpenPlus,
  217288: ContractProduct.FullOpenPlus,
  200008: ContractProduct.Mo,
  208252: ContractProduct.MoClosed,
  217299: ContractProduct.MoClosed,
  200118: ContractProduct.MoClosed,
  217305: ContractProduct.SimpleXFleet,
  200156: ContractProduct.Mitarbeiterleasing,
}

export const VehicleNatureIcons: Partial<Record<VehicleNature, string>> = {
  [VehicleNature.Passenger]: 'icon-car-big',
  [VehicleNature.LightCommercial]: 'icon-miniVan',
  [VehicleNature.HeavyCommercial]: 'icon-van-big',
  [VehicleNature.Motorcycle]: 'icon-motorcycle',
  [VehicleNature.Bicycle]: 'icon-bicycle',
  [VehicleNature.Other]: 'icon-car-wrap',
  [VehicleNature.DeliveryTruck]: 'icon-van-big',
  [VehicleNature.Truck]: 'icon-truck-big',
  [VehicleNature.AlsoPassenger]: 'icon-car-big',
  [VehicleNature.AlsoMotorcycle]: 'icon-motorcycle',
  [VehicleNature.Undefined]: 'icon-4u',
  [VehicleNature.ChargingStation]: 'icon-electric-station',
  [VehicleNature.Trailer]: 'icon-trailer',
}

export class Contracts {
  public static getExtendedContractState(contract: ContractViewModel, expirationDays?: number) {
    if (expirationDays !== undefined) {
      const now = new Date()
      const future = new Date()
      future.setDate(future.getDate() + expirationDays)
      const contractEndDate = contract.endDate ? new Date(contract.endDate) : undefined
      if (contractEndDate && now <= contractEndDate && contractEndDate <= future) {
        return 'Expiring'
      }
    }
    if (contract.state === ContractState.Initialized && !!contract?.vehicle?.chassisNumber) {
      return 'SettingUp'
    }

    return contract.state
  }

  public static getContractProduct(contract: ContractViewModel) {
    return contract.productId ? ContractProductMap[contract.productId] : undefined
  }

  public static getContractNeedReplacementOrder(contract: ContractViewModel, expirationDays?: number) {
    const replacementWindow = Math.max(expirationDays ?? 180, 180) * 1000 * 60 * 60 * 24
    let shouldHaveReplacement =
      contract.endIntention === EndIntention.Undefined || contract.endIntention === EndIntention.VehicleToLogistic
    shouldHaveReplacement &&= new Date(contract.endDate).getTime() - new Date().getTime() < replacementWindow
    return shouldHaveReplacement
  }
}
